import React from 'react';
import { Users, TrendingUp, FolderKanban, ShieldCheck, Layers, BarChart3 } from 'lucide-react';
import { Reveal } from './ui/Reveal';
export const Moat = () => {
  return <section className="py-24 bg-gray-50 border-y border-gray-100" data-id="element-883" data-mp="1defqjq5ys5rf">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-884" data-mp="1dc31yu5pax5e">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-885" data-mp="1i5xpy9sc9yaa">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-886" data-mp="1n4924r63wkvo">
            The elite layer of the creator economy, connected
          </h2>
          <p className="text-lg text-gray-600" data-id="element-887" data-mp="1r3zs4snt6wz5">
            A static list always needs updating and is limited to your personal
            network. A live network of 400+ agencies makes it scalable to
            partner with talent agencies and removes the manual work.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-888" data-mp="1s7euj2sy9r5">
          {[{
          title: 'Live roster data updated by agencies',
          icon: <Users className="text-blue-500" data-id="element-889" data-mp="37ztvenldv1ed" />
        }, {
          title: 'Performance stats updated by Zano',
          icon: <TrendingUp className="text-green-500" data-id="element-890" data-mp="3368xswnpc9fp" />
        }, {
          title: 'Direct manager contact info',
          icon: <FolderKanban className="text-purple-500" data-id="element-891" data-mp="2u86rc1l78ol1" />
        }, {
          title: '400+ agencies vetted by our team',
          icon: <ShieldCheck className="text-orange-500" data-id="element-892" data-mp="3qvjyyf8ys5ud" />
        }, {
          title: '6,000+ represented creators',
          icon: <Layers className="text-pink-500" data-id="element-893" data-mp="3hw6p3lgxhf94" />
        }, {
          title: 'Active Creator Network feed',
          icon: <BarChart3 className="text-indigo-500" data-id="element-894" data-mp="3cxlpno9i2zlq" />
        }].map((item, idx) => <Reveal key={idx} delay={idx % 3 * 0.08} className="h-full" data-id="element-895" data-mp="26j4aux2ax1s4" data-mpi={idx}>
              <div className="h-full bg-white p-6 rounded-xl border border-gray-200 shadow-sm flex items-start gap-4 hover:border-zano-pink/40 hover:shadow-float hover:-translate-y-1 transition-all duration-300" data-id="element-896" data-mp="21hx2avsc3yke">
                <div className="p-2 bg-gray-50 rounded-lg border border-gray-100" data-id="element-897" data-mp="27ygi2tfpi817">
                  {item.icon}
                </div>
                <h3 className="font-medium text-gray-900" data-id="element-898" data-mp="1y0shvnzc08bn">{item.title}</h3>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
};